import { render } from "./UserMenu.vue?vue&type=template&id=eca4e400&scoped=true&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=eca4e400&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c14bfaf61e4aff3d2996531c89f90cfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca4e400"]])

export default __exports__